module.exports = __webpack_public_path__ + "img/icon_hyt_success@3x.e33fafc2.png";